// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"198f137e","453":"a0c3e857","732":"115a7c10"}[chunkId] + ".chunk.js";
};